import * as Styles from './styles';

const PageLoadingSpinner = () => (
  <Styles.Wrapper className="center">
    <Styles.Spinner />
  </Styles.Wrapper>
);

export default PageLoadingSpinner;
